<template>
  <div id="app">
    <router-view></router-view>
    <DialogShare :shareConfig="shareConfig" v-model="showShareDialog" />

    <!-- 提前加载图片，防止海报生成图片加载失败 -->
    <img crossorigin="anonymous" :src="shareConfig.poster" hidden>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DialogShare from '@/components/dialog-share';
import { compareVersion } from '@/utils/utils';

export default {
  components: {
    DialogShare
  },
  data() {
    return {
      showShareDialog: false
    };
  },
  computed: {
    ...mapState({
      shareConfig: state => state.share.shareConfig,
      shareUrl: state => state.share.shareUrl
    })
  },
  mounted() {
    // 监听弹出海报
    this.$bus.$on('openShareDialog', () => {
      if (this.env.inAPP && compareVersion(Sailer.getVersion(), '5.7.9')) {
        const shareData = {
          title: this.shareConfig.title,
          desc: this.shareConfig.content,
          link: this.shareUrl,
          imageUrl: this.shareConfig.imageUrl || 'http://static.91jkys.com/activity/img/d3a997de75364ca1a5d81ad9065d5567.png'
        };
        Sailer.openShare(shareData);
      } else {
        this.showShareDialog = true;
      }
    });
  },
  beforeDestroy() {
    // 解决app手机验证码登录时，替换首页路由的问题
    if (this.$loginTimer) {
      clearTimeout(this.$loginTimer);
    }
  }
};
</script>

<style lang="less">
body {
  background: #f5f5f5;
}

#app {
  min-height: 100vh;
  // 解决ios15字体导致的 html2canvas bug
  // https://github.com/niklasvh/html2canvas/issues/2633
  font-family: Helvetica, Tahoma, Arial, 'PingFang SC', 'Hiragino Sans GB', 'Heiti SC', STXihei, 'Microsoft YaHei',SimHei;
}

.van-popup {
  background-color: transparent !important;
}
</style>
